export default {
    // हेडर सेक्शन
    "discover_your": "खोजें अपना",
    "dasha_phal": "दशा फल",
    "planetary_periods_analysis": "ग्रह दशा विश्लेषण",
    "dasha_phal_description": "आपकी विम्शोत्तरी महादशा यात्रा में करियर वृद्धि, धन, सम्मान और सहयोगी संबंधों के मजबूत चरण दिखाई देते हैं, विशेष रूप से शुक्र, सूर्य, चंद्रमा, मंगल, राहु और शनि की अवधियों में।",

    // सेवा जानकारी
    "enter_birth_details": "अपनी जन्म जानकारी दर्ज करें",
    "complete_dasha_phal_analysis": "पूर्ण दशा फल विश्लेषण",
    "service_price": "सेवा मूल्य",
    "comprehensive_dasha_analysis_note": "आपके जीवन को प्रभावित करने वाली सभी मुख्य और उपग्रह ग्रह अवधियों का व्यापक विश्लेषण",

    // फॉर्म फ़ील्ड्स
    "full_name": "पूरा नाम",
    "enter_full_name": "अपना पूरा नाम दर्ज करें",
    "email_address": "ईमेल पता",
    "enter_email_address": "अपना ईमेल पता दर्ज करें",
    "phone_number": "फोन नंबर",
    "enter_phone_number": "अपना फोन नंबर दर्ज करें",
    "gender": "लिंग",
    "male": "पुरुष",
    "female": "महिला",
    "other": "अन्य",
    "date_of_birth": "जन्म तिथि",
    "time_of_birth": "जन्म समय",
    "exact_time_critical_for_dasha": "सटीक जन्म समय सही दशा गणना के लिए आवश्यक है",
    "place_of_birth": "जन्म स्थान",
    "place_of_birth_placeholder": "शहर, राज्य, देश",
    "preferred_language": "पसंदीदा भाषा",
    "english": "अंग्रेज़ी",
    "hindi": "हिंदी",
    "telugu": "तेलुगु",
    "kannada": "कन्नड़",
    "language_note": "आपका विश्लेषण चुनी हुई भाषा में दिया जाएगा",

    // विशेषताएँ और लाभ
    "current_dasha_period_analysis": "वर्तमान दशा अवधि विश्लेषण",
    "planetary_influence_detailed": "विस्तृत ग्रह प्रभाव",
    "future_dasha_predictions": "भविष्य की दशा भविष्यवाणियां",
    "career_and_finance_guidance": "करियर और वित्त मार्गदर्शन",
    "remedial_measures": "उपाय",
    "pdf_download": "पीडीएफ डाउनलोड",

    "what_you_get": "आपको क्या मिलेगा",
    "current_mahadasha_antardasha": "वर्तमान महादशा और अंतर्दशा",
    "planetary_effects_detailed": "विस्तृत ग्रह प्रभाव",
    "timing_of_events": "महत्वपूर्ण घटनाओं का समय",
    "future_dasha_timeline": "भविष्य दशा समयरेखा",

    // क्रियाएं और बटन
    "pay_and_generate_chart": "भुगतान करें और विश्लेषण बनाएं",
    "processing_payment": "भुगतान संसाधित हो रहा है",
    "processing_request": "अनुरोध संसाधित हो रहा है",

    // भुगतान और सफलता संदेश
    "thank_you": "धन्यवाद",
    "payment_successful": "भुगतान सफल!",
    "dasha_phal_analysis_processing": "आपका दशा फल विश्लेषण अनुरोध प्राप्त हो गया है और हमारे विशेषज्ञ ज्योतिषी इसे संसाधित कर रहे हैं।",
    "order_id": "ऑर्डर आईडी",
    "payment_id": "भुगतान आईडी",
    "amount_paid": "भुगतान राशि",

    // डिलीवरी जानकारी
    "delivery_information": "डिलीवरी जानकारी",
    "delivery_time": "डिलीवरी समय",
    "within_12_hours_delivery_note": "आपका विश्लेषण 12 घंटे के भीतर दिया जाएगा",
    "whatsapp_notification": "व्हाट्सऐप सूचना",
    "whatsapp_delivery_note": "आपको व्हाट्सऐप पर अपडेट मिलेगा",
    "email_delivery": "ईमेल डिलीवरी",
    "email_delivery_note": "विश्लेषण भेजा जाएगा",

    // आपको क्या प्राप्त होगा
    "what_youll_receive": "आपको क्या मिलेगा",
    "detailed_dasha_phal_report": "विस्तृत दशा फल रिपोर्ट (पीडीएफ)",
    "current_planetary_periods": "वर्तमान ग्रह अवधि विश्लेषण",
    "future_dasha_predictions_timeline": "भविष्य दशा भविष्यवाणी समयरेखा",
    "planetary_remedies_guidance": "ग्रह उपाय और मार्गदर्शन",
    "career_finance_predictions": "करियर और वित्त भविष्यवाणी",

    // दृश्य सामग्री
    "sample_dasha_phal": "नमूना दशा फल विश्लेषण",
    "sample_dasha_phal_description": "आपका विस्तृत दशा फल विश्लेषण इस प्रकार दिखेगा",
    "major_planetary_periods": "मुख्य ग्रह अवधियां",

    // ग्रह अवधियां
    "sun_dasha": "सूर्य दशा",
    "moon_dasha": "चंद्रमा दशा",
    "mars_dasha": "मंगल दशा",
    "mercury_dasha": "बुध दशा",
    "jupiter_dasha": "बृहस्पति दशा",
    "venus_dasha": "शुक्र दशा",

    // स्थिति और संसाधन
    "your_dasha_phal_analysis_status": "आपके दशा फल विश्लेषण की स्थिति",
    "processing_your_analysis": "आपका विश्लेषण संसाधित हो रहा है",
    "analysis_processing_message": "हमारे विशेषज्ञ ज्योतिषी आपकी जन्म कुंडली और ग्रह अवधियों का सावधानीपूर्वक विश्लेषण कर रहे हैं।",
    "request_id": "अनुरोध आईडी",
    "status": "स्थिति",
    "processing": "संसाधन हो रहा है",
    "pending": "लंबित",
    "email_notification_sent": "ईमेल सूचना भेजी गई",
    "whatsapp_update_coming": "व्हाट्सऐप अपडेट जल्द आ रहा है",
    "delivery_within_12_hours": "12 घंटे के भीतर डिलीवरी",

    // सहायता और संपर्क
    "contact_support": "सहायता से संपर्क करें",
    "need_help": "मदद चाहिए?",
    "contact_us_at": "हमसे संपर्क करें",

    // त्रुटि संदेश
    "please_fill_all_required_fields": "कृपया सभी आवश्यक फ़ील्ड भरें",
    "payment_failed": "भुगतान विफल। कृपया पुनः प्रयास करें।",
    "processing_failed": "संसाधन विफल। कृपया सहायता से संपर्क करें।",

    // फॉर्म मान्यता संदेश
    "name_required": "नाम आवश्यक है",
    "email_required": "ईमेल आवश्यक है",
    "phone_required": "फोन नंबर आवश्यक है",
    "date_required": "जन्म तिथि आवश्यक है",
    "time_required": "जन्म समय आवश्यक है",
    "place_required": "जन्म स्थान आवश्यक है"
}
